//@constants
const actionTypes = require('constants/actionTypes');
//@core
const { APIPost } = require('utilities/APIRequestHelper');

const cardMovementInstallmentsChartRequest = () => {
    return {
        type: actionTypes.CARD_MOVEMENT_INSTALLMENTS_CHART_REQUEST
    };
};

const cardMovementInstallmentChartsSuccess = response => {
    return {
        type: actionTypes.CARD_MOVEMENT_INSTALLMENTS_CHART_SUCCESS,
        payload: {
            response
        }
    };
};

const cardMovementInstallmentsError = error => {
    return {
        type: actionTypes.CARD_MOVEMENT_INSTALLMENTS_CHART_FAILURE,
        payload: {
            error
        }
    };
};

const getCardMovementInstallmentsChart = (cardId, transactionId) => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId], false);
    const immTransaction = getState().cardsTransactions.getIn([cardId, 'byId', transactionId]);

    if (immTransaction.get('deferPaymentIndicator') === 'F') {
        // F means that was deferred.
        const params = {
            query: {
                canalComercializado: 'INT', //fixed value. API has to remove it.
                ctosaldo: immTransaction.getIn(['extra', 'balanceConcept']),
                divisa: immTransaction.getIn(['import', 'currency']),
                fecanota: immTransaction.getIn(['extra', 'movementNoteDay']),
                fecopera: immTransaction.getIn(['extra', 'operationDate']),
                importe: immTransaction.getIn(['import', 'amount']),
                jmodalid: immTransaction.getIn(['extra', 'paymentModality']),
                liamovto: immTransaction.getIn(['extra', 'dayMovementNumber']),
                mlforpag: immTransaction.getIn(['extra', 'paymentMethod']),
                numeroContrato: immCard.getIn(['contract', 'number']),
                panTarjeta: immCard.get('number'),
                producto: immCard.getIn(['product', 'type'])
            }
        };

        dispatch(cardMovementInstallmentsChartRequest());
        APIPost({dispatch, endpoint: 'cardRepaymentPlan', params})
            .then(response => dispatch(cardMovementInstallmentChartsSuccess(response)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(cardMovementInstallmentsError(response.error));
                } else {
                    throw response;
                }
            });
    }
}


module.exports = {
    getCardMovementInstallmentsChart
};
